export default "__VITE_ASSET__BSRgYirK__"